import { useTranslation } from "@redotech/redo-i18n";
import CloseIcon from "@redotech/redo-icons/x-close.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoBaseModal } from "@redotech/redo-web/arbiter-components/modal/redo-base-modal";
import { RedoDrawer } from "@redotech/redo-web/arbiter-components/modal/redo-drawer";
import { Flex } from "@redotech/redo-web/flex";
import { memo, ReactNode } from "react";
import * as PortalModalCss from "./portal-modal.module.css";

export const PortalModal = memo(function PortalModal({
  isOpen,
  onModalCloseRequested,
  children,
  isFullScreen,
  isDrawer,
  dataUi,
}: {
  isOpen: boolean;
  onModalCloseRequested?: () => void;
  children?: ReactNode;
  isFullScreen?: boolean;
  isDrawer?: boolean;
  dataUi?: string;
}) {
  const { t } = useTranslation();

  const ModalContent = (
    <Flex data-ui={dataUi} flexDirection="column" gap="none" pb="none">
      <Flex
        data-testid="close-modal-button-container"
        height="none"
        justify="flex-end"
        w="full"
      >
        <Flex data-ui="modal-close-button" p="sm" px="md">
          <RedoButton
            aria-label={t("Close")}
            data-testid="close-modal-button"
            disabled={onModalCloseRequested === undefined}
            hierarchy="tertiary"
            IconLeading={CloseIcon}
            onClick={onModalCloseRequested}
            size="md"
          />
        </Flex>
      </Flex>
      {children}
    </Flex>
  );
  return !isFullScreen ? (
    isDrawer ? (
      <RedoDrawer
        onModalCloseRequested={() =>
          onModalCloseRequested && onModalCloseRequested()
        }
        uiSelector="portal-modal"
      >
        <Flex grow={1}>{ModalContent}</Flex>
      </RedoDrawer>
    ) : (
      <RedoBaseModal
        disableEnforceFocus
        isOpen={isOpen}
        onModalCloseRequested={() =>
          onModalCloseRequested && onModalCloseRequested()
        }
        otherClasses={[PortalModalCss.modal]}
        uiSelector="portal-modal"
      >
        {ModalContent}
      </RedoBaseModal>
    )
  ) : (
    <Flex
      bgColor="primary"
      className={PortalModalCss.fullScreenModal}
      data-ui="portal-modal"
    >
      {children}
    </Flex>
  );
});
